import { Injectable } from "@angular/core";
import { Resolve, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { ContentDetail } from "@models/content-detail";
import { ContentService } from "@services/content.service";
import { GlobalService } from "@services/global.service";

@Injectable()
export class ContentResolverService implements Resolve<ContentDetail[]> {
    constructor(private contentService: ContentService, private globalService: GlobalService, private router: Router) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ContentDetail[]> {
        const id: string = route.params["id"] as string;
        if (id === null) {
            this.router.navigate([this.globalService.getLanguageCode(), "page", "error"], { queryParams: { dt: 1, returnUrl: state.url } });
        }

        let languageId = route.paramMap.get("languageId");
        if (languageId && languageId !== "") {
            this.globalService.setLanguage(languageId);
        } else {
            languageId = this.globalService.getLanguage();
            if (!languageId) {
                this.globalService.setLanguage("en-us");
            }
        }

        return this.resolveContent(id);
    }

    private resolveContent(id: string): Promise<ContentDetail[]> {
        return this.contentService.getDetails(id)
            .toPromise()
            .then(details => {
                if (details === undefined || details === null) {
                    this.router.navigate([this.globalService.getLanguageCode(), "page", "error"], { queryParams: { dt: 1 }});
                    return null;
                }

                return details;
            });
    }
}
